// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../schema';

import gql from '@workspace/graphql-codegen-fetch';
import { ErrorsFragmentDoc } from './UpdateUserSettingsMutation';
export type UserManagementRegisterAsUserInput = {
  address?: string | null | undefined;
  appDevice?: string | null | undefined;
  appOs?: string | null | undefined;
  appTech?: string | null | undefined;
  bonusCode?: string | null | undefined;
  brand?: string | null | undefined;
  captcha?: string | null | undefined;
  captchaVersion?: string | null | undefined;
  cid?: string | null | undefined;
  city?: string | null | undefined;
  cityOfBirth?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  country?: string | null | undefined;
  countryOfBirth?: string | number | null | undefined;
  dateOfBirth?: number | null | undefined;
  domain?: string | null | undefined;
  email?: string | null | undefined;
  firstName?: string | null | undefined;
  friendRef?: string | null | undefined;
  house?: string | null | undefined;
  isApp?: boolean | null | undefined;
  language?: string | null | undefined;
  lastName?: string | null | undefined;
  maidenName?: string | null | undefined;
  middleName?: string | null | undefined;
  nationalIdCountryCode?: string | null | undefined;
  nationalIdPersonalCode?: string | null | undefined;
  offers?: boolean | null | undefined;
  offersCall?: boolean | null | undefined;
  offersSms?: boolean | null | undefined;
  password?: string | null | undefined;
  phone?: string | null | undefined;
  refAff?: string | null | undefined;
  refCode?: string | null | undefined;
  site?: string | null | undefined;
  state?: string | null | undefined;
  username?: string | null | undefined;
  zip?: string | null | undefined;
};

export type RegisterMutationVariables = Exact<{
  input: Types.UserManagementRegisterAsUserInput;
}>;


export type RegisterMutation = { userManagementRegisterAsUser: { token: string | undefined, sessionId: string | undefined, deviceDataToken: string | undefined, userManagement: { currentUser: { username: string | undefined, email: string | undefined } | undefined, currentProfile: { _id: string | undefined } | undefined } | undefined, errors: Array<{ message: string | undefined, params: Array<{ name: string | undefined, value: string | undefined } | undefined> | undefined } | undefined> | undefined } | undefined };


export const RegisterMutationDocument = gql`
    mutation RegisterMutation($input: UserManagementRegisterAsUserInput!) {
  userManagementRegisterAsUser(input: $input) {
    token
    sessionId
    userManagement {
      currentUser {
        username
        email
      }
      currentProfile {
        _id
      }
    }
    deviceDataToken
    errors {
      ...ErrorsFragment
    }
  }
}
    ${ErrorsFragmentDoc}`;